﻿import {KeysetQuery} from "@2d-front-monorepo/core";
import {ErrorMessage, KeysetPager, PopOver, RemoteDataStatus, useRemoteData} from "@2d-front-monorepo/design-library";
import {PermitId, PermitResult, PermitStatusComponent} from "@2d-front-monorepo/permits-business";

import {JSX, useState} from "react";
import PermitsInlineLoading from "../../components/PermitsInlineLoading";
import Registrations from "../../customers/Registrations";
import {getHttpClient} from "../../hooks/getHttpClient";
import PermitDates from "./ViewComponents/PermitDates";
import PermitStatusReason from "./ViewComponents/PermitStatusReason";
import PermitTariffZone from "./ViewComponents/PermitTariffZoneResidencyVehicles";
import {PermitTotalComponent} from "./ViewComponents/PermitTotalComponent";

function Permit({permit}: { permit: PermitResult }): JSX.Element {
	// Called as a plain function, so a tenant menu's hooks belong to this component -
	// fine, the call is unconditional.
	const menu = Registrations.getArchivedPermitMenu()({permit});

	return (
		<section className="card">
			<header className="layout horizontal aligned middle" id={"p_" + permit.id}>
				<div className="flex"><PermitDates permit={permit}/></div>
				<div className="permit__header-actions">
					<PermitStatusComponent permit={permit}/>
					{menu.length > 0 && <div><PopOver>{menu}</PopOver></div>}
				</div>
			</header>
			<PermitStatusReason permit={permit}/>

			<hr className="no-margin"/>
			<PermitTariffZone permit={permit}/>
			<PermitTotalComponent permit={permit}/>
		</section>
	);
}

export default function ArchivedPermits(): JSX.Element {
	const [query, setQuery] = useState<KeysetQuery<PermitId>>({});
	const {data, status, error} = useRemoteData(signal => getHttpClient().permits.archived(query, signal), [query]);

	// Only the first load gets the spinner; paging keeps the previous cards on screen and
	// just dims them, so the tab does not empty out on every click.
	if (status === RemoteDataStatus.Loading && data == null) {
		return <PermitsInlineLoading/>;
	}

	if (status === RemoteDataStatus.Error) {
		return <ErrorMessage error={error}/>;
	}

	const permits = data!.data;
	const loading = status === RemoteDataStatus.Loading;

	return (
		<div className={loading ? "layout--loading" : undefined}>
			<div className="layout vertical gap">
				{permits.map(
					permit => {
						return <Permit key={permit.id} permit={permit}/>
					})
				}
			</div>
			<KeysetPager keyField={"id"} items={data!} onPageChange={setQuery}/>
		</div>
	);
}
